var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductCatalog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3350_32657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 53.3333C14.8054 53.3333 15.9993 52.1394 15.9993 50.6667C15.9993 49.1939 14.8054 48 13.3327 48C11.8599 48 10.666 49.1939 10.666 50.6667C10.666 52.1394 11.8599 53.3333 13.3327 53.3333Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.666 10.667H15.9993V34.667H10.666V10.667Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6673 5.33301H8.00065C7.29341 5.33301 6.61513 5.61396 6.11503 6.11406C5.61494 6.61415 5.33398 7.29243 5.33398 7.99967V55.9997C5.33398 56.7069 5.61494 57.3852 6.11503 57.8853C6.61513 58.3854 7.29341 58.6663 8.00065 58.6663H18.6673C19.3746 58.6663 20.0528 58.3854 20.5529 57.8853C21.053 57.3852 21.334 56.7069 21.334 55.9997V7.99967C21.334 7.29243 21.053 6.61415 20.5529 6.11406C20.0528 5.61396 19.3746 5.33301 18.6673 5.33301ZM18.6673 55.9997H8.00065V7.99967H18.6673V55.9997Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0007 53.3333C33.4734 53.3333 34.6673 52.1394 34.6673 50.6667C34.6673 49.1939 33.4734 48 32.0007 48C30.5279 48 29.334 49.1939 29.334 50.6667C29.334 52.1394 30.5279 53.3333 32.0007 53.3333Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.334 10.667H34.6673V34.667H29.334V10.667Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 5.33301H26.6667C25.9594 5.33301 25.2811 5.61396 24.781 6.11406C24.281 6.61415 24 7.29243 24 7.99967V55.9997C24 56.7069 24.281 57.3852 24.781 57.8853C25.2811 58.3854 25.9594 58.6663 26.6667 58.6663H37.3333C38.0406 58.6663 38.7189 58.3854 39.219 57.8853C39.719 57.3852 40 56.7069 40 55.9997V7.99967C40 7.29243 39.719 6.61415 39.219 6.11406C38.7189 5.61396 38.0406 5.33301 37.3333 5.33301ZM37.3333 55.9997H26.6667V7.99967H37.3333V55.9997Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6667 53.3333C52.1394 53.3333 53.3333 52.1394 53.3333 50.6667C53.3333 49.1939 52.1394 48 50.6667 48C49.1939 48 48 49.1939 48 50.6667C48 52.1394 49.1939 53.3333 50.6667 53.3333Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 10.667H53.3333V34.667H48V10.667Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9993 5.33301H45.3327C44.6254 5.33301 43.9472 5.61396 43.4471 6.11406C42.947 6.61415 42.666 7.29243 42.666 7.99967V55.9997C42.666 56.7069 42.947 57.3852 43.4471 57.8853C43.9472 58.3854 44.6254 58.6663 45.3327 58.6663H55.9993C56.7066 58.6663 57.3849 58.3854 57.885 57.8853C58.3851 57.3852 58.666 56.7069 58.666 55.9997V7.99967C58.666 7.29243 58.3851 6.61415 57.885 6.11406C57.3849 5.61396 56.7066 5.33301 55.9993 5.33301ZM55.9993 55.9997H45.3327V7.99967H55.9993V55.9997Z",
    fill: "#39ACE7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3350_32657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCatalog);
export default __webpack_public_path__ + "static/media/Product Catalog.f427894fc0c393ede0ff185db349a9b7.svg";
export { ForwardRef as ReactComponent };